<ui-modal modalTitle="Dependency Details" size="md" [scrollable]="true">
	<ng-container *ngIf="dependency">
		<div *ngIf="image_urls.length" class="d-flex align-items-center justify-content-center">
			<div class="d-flex align-items-center mr-2" style="font-size: 1.2rem; height: 100%; width: 1.5rem;">
				<i class="wq wq-arrow-left" [ngClass]="{'d-none': currentIndex === 0}" (click)="prev()" style="cursor: pointer;"></i>
			</div>
			<ng-container *ngIf="image; else noImage">
				<img [src]="image" class="w-90 mb-2 border border-8 border-lightgrey rounded" style="min-height: 30rem;">
			</ng-container>

			<ng-template #noImage>
				<div class="w-90 mb-2 border border-8 border-lightgrey rounded" style="height: 30rem;">&nbsp;</div>
			</ng-template>
			<div class="d-flex align-items-center ml-2" style="font-size: 1.2rem; height: 100%; width: 1.5rem;">
				<i (click)="next()" [ngClass]="{'d-none': currentIndex === (image_urls.length - 1)}" class="wq wq-arrow-right" style="cursor: pointer;"></i>
			</div>
		</div>
		<div *ngIf="!image_urls.length" style="word-break: break-word;" class="w-100 mb-2 border border-8 border-lightgrey rounded p-2 text-pre text-small overflow-hidden bg-white">{{dependency.text_content}}</div>
		<div class="text-small">
			<div><i class="wq wq-dependency-{{dependency.type}} mr-1 text-large text-primary"></i> <span class="text-secondary">{{dependency.name}}</span></div>
			<div class="text-bold">{{dependency.user_name}}</div>
			<div class="text-tiny text-secondary mb-1">{{dependency.completed_datetime | mySQLDateToISO | localizedDate:'shortDate'}} {{dependency.completed_datetime | mySQLDateToISO | localizedDate:'shortTime'}}</div>
			<div class="text-lines lines-1 mb-1 text-small mb-1" [ngClass]="{'selectable': from !== 'task'}" (click)="openTaskDetails(dependency)" uiEllipsisTooltip>
				<b class="text-info">{{dependency.parent_id ? 'Subtask' : 'Task'}} :</b> {{dependency.task_name}}
			</div>
			<span class="selectable" ngbTooltip="Go To job" (click)="goToWorkOrder(dependency)"><b>Job:</b> {{dependency.work_order_no}} - {{dependency.work_order_name}}</span>
		</div>
	</ng-container>

	<a *ngIf="dependency && image" class="btn btn-primary mr-2" [href]="image" target="_blank" download ui-modal-footer><i class="wq wq-download mr-2"></i>Download Image</a>
	<button type="button" class="btn btn-secondary" (click)="modal.close()" ui-modal-footer>Close</button>
</ui-modal>

<app-modal-task-details *ngIf="from !== 'task'" (close)="taskDetailsModalClosed($event)"></app-modal-task-details>
